export default __webpack_public_path__ + "static/media/default_head.d12c6259.svg";